var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ListReports", {
    ref: "reports",
    attrs: { "load-on-start": false, resource: "opportunities" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }